// SmartPatrolImageDownloader.tsx
// Component use to handle download image link from excel export
import React from 'react'
import { Redirect, useParams } from 'react-router-dom'

import useSafeEffect from 'src/commons/hooks/useSafeEffect'

import { downloadSmartPatrolOffensesImages } from './requests'

interface IParamsType {
  offenseId?: string
}

export default function SmartPatrolImageDownloader() {
  const { offenseId } = useParams<IParamsType>()

  useSafeEffect(() => {
    if (offenseId) {
      downloadSmartPatrolOffensesImages({ offense_uid: offenseId })
        .then(() => {
          console.info('Downloading Image')
        })
        .catch(() => {
          console.error('Fail to download image')
        })
    }
  }, [])

  return <Redirect to={'/policies/smart_patrol'} />
}
